import { Component, DestroyRef, OnInit } from '@angular/core';
import {
  enumToDescriptedArray,
  LocalizationTranslationConst,
  LocalizationType,
} from '@shared/core';
import { LocalizationService } from '@shared/modules/localization';
import { UISelectMini } from '@shared/ui';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'pkp-g-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  imports: [UISelectMini],
})
export class LanguageSelectorComponent implements OnInit {
  langList = enumToDescriptedArray(LocalizationType).map(item => {
    item.description = LocalizationTranslationConst[item.id] ?? '';
    return item;
  });

  selectedLang: LocalizationType | undefined;

  constructor(private localizationService: LocalizationService, private destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.selectedLang = this.localizationService.currentLanguage;
  }

  onSelectedLangChanged(lang: unknown): void {
    if (this.selectedLang === lang) return;
    this.localizationService
      .setCurrentLang(lang as LocalizationType)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => location.reload());
  }
}
